import * as React from 'react';
import './styles.scss'

import "aos/dist/aos.css";


const Loading = () => {
    return (
        <>
            <div className="root">
                <div className="contenedor" >
                    <img src='/assets/logos/logoIsoBlanco.png' alt="banner"  className='imgLoading'/>
                </div>
            </div>

        </>

    )
}

export default Loading